define(function () {
    /**
     * Create a countdown
     *
     * updateCallback
     *
     * @param {number} time Countdown in seconds.
     * @param {function} updateCallback is called every second until countdown reaches zero.
     * @param {function} completeCallback is called when countdown reaches zero.
     *
     */
    function createCountdown(time, updateCallback, completeCallback) {
        var start = new Date().getTime();

        var interval = setInterval(function () {
            var now = (time * 1000) - (new Date().getTime() - start);
            if (now <= 0) {
                clearInterval(interval);
                if (typeof completeCallback == 'function') completeCallback();
            } else {
                if (typeof updateCallback == 'function') updateCallback(Math.floor(now / 1000));
            }
        }, 1000);
    }


    /**
     * Creates and returns a new debounced version of the passed function which will
     * postpone its execution until after threshold milliseconds have elapsed since the
     * last time it was invoked.
     *
     * Pass true for the execAsap parameter to cause debounce to trigger the function on
     * the leading instead of trailing edge of the threshold interval.
     *
     * @param func
     * @param threshold
     * @param execAsap
     * @returns {function}
     */
    function debounce(func, threshold, execAsap) {
        var timeout;
        return function debounced() {
            var obj = this, args = arguments;

            function delayed() {
                if (!execAsap)
                    func.apply(obj, args);
                timeout = null;
            }

            if (timeout)
                clearTimeout(timeout);
            else if (execAsap)
                func.apply(obj, args);

            timeout = setTimeout(delayed, threshold || 100);
        };
    }


    /**
     * Combine url paths into one path.
     *
     * Example:
     *
     * combineUrl( '/test', 'level2', '../level3/level4.html' );
     *
     * result:
     * /test/level3/level4.html
     *
     * @param {...string}
     * @returns {string|string}
     */
    function combineUrl() {
        var parts = [];
        for (var i = 0, l = arguments.length; i < l; i++) {
            parts = parts.concat(arguments[i].split("/"));
        }
        var newParts = [];
        for (i = 0, l = parts.length; i < l; i++) {
            var part = parts[i];
            if (!part || part === '.') continue;
            if (part === '..') {
                newParts.pop();
            } else {
                newParts.push(part);
            }
        }
        if (parts[0] === '') newParts.unshift('');
        return newParts.join('/') || (newParts.length ? '/' : '.');
    }

    /**
     * Convert db price format to js floating point
     *
     * @param price
     * @returns {number}
     */
    function toPrice(price) {
        try {
            price = parseInt(price, 10);
            return price / 100;
        } catch (e) {
            console.error(e);
            return 0;
        }
    }


    /**
     * Convert js floating point to db price format
     *
     * @param price
     * @returns {number}
     */
    function fromPrice(price) {
        try {
            return price * 100;
        } catch (e) {
            console.error(e);
            return 0;
        }
    }


    /**
     * Hostname mapping helper
     *
     * Mapping urls between dev/staging/beta/prod. If url doesn't start with "https://www.unisport" or current hostname
     * do contains ".unisport" it just returns the url unmodified.
     *
     * Example:
     *
     * urlMapping( 'https://www.unisport.dk/about' );
     *
     * result when called from sv.dev
     * http://dk.dev/about
     *
     *
     * urlMapping( 'https://www.unisportstore.com/about' );
     *
     * result on dk.staging.unisport.dk
     * http://en.staging.unisport.dk/about
     *
     * @param url
     * @return {string}
     */
    function urlMapping(url) {
        var hostname = location.hostname || "",
            tldExp = /^(?:https?:\/\/)?(?:[\da-z\.-]+)\.([a-z\.]{2,6})(?:\/(?:[\/\w \.-]*)*\/?)?/i,
            mapping = {'com': 'en', 'dk': 'da', 'se': 'sv' },
            newUrl, tld, m;

        if( "string" != typeof( url )
            || !(url.lastIndexOf('https://www.unisport',0) === 0)
            || hostname.indexOf('.unisport') !== -1 && hostname.indexOf('.dev') === -1 ) {
            return url;
        }

        if( (m = tldExp.exec(url)) !== null && m.length > 1) tld = m[1];
        if( mapping[tld] ) tld = mapping[tld];

        if( hostname.lastIndexOf('beta.',0) === 0 ) {
            newUrl = url.replace(/^.*\/\/[^\/]+/, 'http://beta' + hostname.substring(3) );
        } else if( /^[a-zA-Z]{2,3}[.]staging.unisport.dk$/i.test(hostname) ) {
            if( tld === 'en' ) tld = 'com';
            newUrl = url.replace(/^.*\/\/[^\/]+/, 'http://' + tld + '.staging.unisport.dk' );
        } else if( /^[a-zA-Z]{2}[.]dev$/i.test(hostname) ) {
            newUrl = url.replace(/^.*\/\/[^\/]+/, 'http://' + tld + '.dev' );
        }
        return newUrl;
    }


    /**
     * Create DOM element helper function
     *
     * Create and return a new DOM element. The tagName argument should be an html tag name string
     * (eg. 'div', 'span', etc).
     *
     * The props argument should contain an object with properties to initialize the element (eg. 'className', 'href',
     * 'src', etc).
     *
     * @param tagName
     * @param {object=} props
     * @param {...object} children
     * @returns {Element}
     */
    function createElement(tagName, props, children) {
        var el = document.createElement(tagName);

        if (props) {
            for (var prop in props) {
                if (props.hasOwnProperty(prop)) {
                    el[prop] = props[prop];
                }
            }
        }

        var childrenLength = arguments.length - 2;
        if (childrenLength >= 1) {
            for (var i = 0; i < childrenLength; i++) {
                el.appendChild(arguments[i + 2]);
            }
        }

        return el;
    }

    return {
        createCountdown: createCountdown,
        debounce: debounce,
        combineUrl: combineUrl,
        toPrice: toPrice,
        fromPrice: fromPrice,
        urlMapping: urlMapping,
        createElement: createElement
    }

});
